/** The agency's name read from its settings (multi-tenant: never written in the texts). */
import { useAcademyAgencyName } from "@agencyos/api-client";
import { useTranslation } from "react-i18next";

/** "Contact <agency> to join this course" under the beginner card. */
export function BeginnerNext() {
  const { t } = useTranslation();
  const agency = useAcademyAgencyName();
  return <p className="ac-secondary">{t("academy.beginner.next", { agency: agency || t("academy.agencyFallback") })}</p>;
}
